import React from 'react'
import { Link } from 'react-router-dom'

const Header = () => {
    return (
        <>

            <header id="header">
                <div class="d-flex flex-column">

                    <div class="profile">
                        <img src="assets/img/profile-img.png" alt="" class="img-fluid rounded-circle" />
                        <h1 class="text-light"><a href="">Ansh Varshney</a></h1>
                        <div class="social-links mt-3 text-center">
                            <a href="#" class="twitter"><i class="bx bxl-twitter"></i></a>
                            <a href="#" class="facebook"><i class="bx bxl-facebook"></i></a>
                            <a href="#" class="instagram"><i class="bx bxl-instagram"></i></a>
                            <a href="https://discord.com/channels/__ryder__#5395" class="google-plus"><i class="bx bxl-discord"></i></a>
                            <a href="https://www.linkedin.com/in/ansh-varshney-84b5821b6/" class="linkedin"><i class="bx bxl-linkedin"></i></a>
                        </div>
                    </div>

                    <nav id="navbar" class="nav-menu navbar">
                        <ul>
                            <li><Link to='/' class="nav-link scrollto active"><i class="bx bx-home"></i> <span>Home</span></Link></li>
                            <li><a href="#about" class="nav-link scrollto"><i class="bx bx-user"></i> <span>About</span></a></li>
                            <li><a href="#resume" class="nav-link scrollto"><i class="bx bx-file-blank"></i> <span>Resume</span></a></li>
                            <li><a href="#portfolio" class="nav-link scrollto"><i class="bx bx-book-content"></i> <span>Portfolio</span></a></li>
                            <li><a href="#contact" class="nav-link scrollto"><i class="bx bx-envelope"></i> <span>Contact</span></a></li>
                        </ul>
                    </nav>
                </div>
            </header>


        </>
    )
}

export default Header